import React, { useState } from "react";
import { ACTIVITY_LOG_ICONS, COPIED_ICON, CRAFT_LOGO } from "src/constants/images";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { PROFILE, MARKET_PLACE, WALLET } from "src/constants/routes";
import { daysAgo } from "utils/daysAgo";
import { nFormatter } from "utils/nFormatter";
import SKActivityLogRow from "../Loader/Skeleton/ActivitLogRow.skeleton";
export default function ActivityTable(props) {
  const { activity, icxRate, _ParseTypeToProperGrammar, isLoading } = props;
  const navigate = useNavigate();
  const [isCopied, setIsCopied] = useState(false);
  const [alert, setAlert] = useState(false);

  const redirectHandler = (id) => {
    const route = PROFILE.addSlug(PROFILE.INDEX, id);

    navigate(route);
  };
  const handleRedirection = (type) => {
    navigate(`${MARKET_PLACE.INDEX}?class_type=${type}`);
    //! Try using stats instead of loading for optimal use
    window.location.reload();
  };
  const handleCopied = (item) => {
    setIsCopied(!isCopied);
    navigator.clipboard.writeText(item);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
    }, 3000);
  };
  return (
    <div className="table-container">
      {alert && (
        <div
          className="alert alert-primary alert-dismissible fade show px-5"
          role="alert"
        >
          Transaction Hash Copied!
        </div>
      )}
      <table>
        <thead>
          <tr>
            <th>Type</th>
            <th>Item</th>
            <th>From</th>
            <th>To</th>
            <th>Price</th>
            <th>$GBET used</th>
            {/* <th>Time</th> */}
          </tr>
        </thead>
        <tbody>
          {isLoading
            ? [...Array(20)].map((elementInArray, index) => (
                <SKActivityLogRow />
              ))
            : null}

          {!isLoading
            ? activity.map((data, index) => (
                <tr key={index} className="al-rowValues">
                  <td className="al-type">
                    <div className="d-flex">
                      <div className="al-typeIcon">
                        <img
                          src={ACTIVITY_LOG_ICONS[data.activity_type]}
                          className="filterBg"
                        />
                        {/* {ACTIVITY_LOG_ICONS.NAME_CHANGE_SVG("#ffffff")} */}
                      </div>
                      <div className="al-typeDesc">
                        <div className="al-typeName">
                          {_ParseTypeToProperGrammar(data.activity_type)}
                        </div>
                        <div className="al-typeTime">
                          <div>
                            {daysAgo(data.createdAt)}
                            {/* ...{data.txhash.substr(58)}
                        <span
                          className="btn p-0 ms-1 "
                          onClick={() => handleCopied(data.txhash)}
                        >
                          <img
                            src={COPIED_ICON.SOURCE}
                            style={{ width: "14px", height: "14px" }}
                            alt="copied-item"
                            className="mb-1"
                          />
                        </span> */}
                          </div>
                        </div>
                        {data.from_craft ? (
                          <div className="al-cft">
                            <div className="type-tt hover-text">
                              Sold on Craft Marketplace
                            </div>
                            <img src={CRAFT_LOGO.SOURCE} />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </td>
                  <td className="al-item">
                    <div className="d-flex">
                      <NavLink
                        to={`/profile/${parseInt(data.nft_id, 16)}`}
                        onClick={() => {
                          redirectHandler(parseInt(data.nft_id, 16));
                        }}
                        className="al-gangstaImg"
                      >
                        <img src={data.token_uri} />
                      </NavLink>
                      <div className="al-gangstaInfo">
                        <NavLink
                          to={`/profile/${parseInt(data.nft_id, 16)}`}
                          className="al-nameTitle"
                          onClick={() => {
                            redirectHandler(parseInt(data.nft_id, 16));
                          }}
                        >
                          {data.token_name}
                        </NavLink>
                        <NavLink
                          to={`/profile/${parseInt(data.nft_id, 16)}`}
                          className="al-itemSubInfos"
                          onClick={() => {
                            redirectHandler(parseInt(data.nft_id, 16));
                          }}
                        >
                          <span
                            className="al-itemTokenNumber"
                            style={{ color: "var(--black)" }}
                          >
                            {`#${parseInt(data.nft_id, 16)}`} ·
                          </span>{" "}
                          <span className="al-itemClass"> {data.type} </span>
                        </NavLink>
                        <div className="al-stats">
                          <div
                            onClick={() => {
                              handleRedirection(data.class_type);
                            }}
                            className={`al-badge class-type gangsta-class-type ${data.class_type.toLowerCase()}`}
                          >
                            {data.class_type}
                          </div>
                          <div
                            onClick={() => {
                              redirectHandler(parseInt(data.nft_id, 16));
                            }}
                            className="al-skill"
                          >
                            {/* Skill: <span> 178</span> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="al-hxHash">
                    <div>
                      <NavLink to={`/wallet/${data.from}`}>
                        ...{data.from.substr(data.from.length - 7)}
                      </NavLink>
                    </div>
                  </td>
                  <td className="al-hxHash">
                    <div>
                      {data.to ? (
                        <NavLink to={`/wallet/${data.to}`}>
                          ...{data.to.substr(data.to.length - 7)}
                        </NavLink>
                      ) : null}
                    </div>
                  </td>
                  <td className="al-amount">
                    <div className="inherit">
                      <div className="al-icx">
                        {data.price ? (
                          <>
                            {nFormatter(data.price)}
                            <span style={{ fontSize: "14px" }}> ICX</span>
                          </>
                        ) : null}
                      </div>
                      <div className="al-usd">
                        {data.price ? (
                          <>
                            {`($${
                              data.usd_price
                                ? nFormatter(data?.usd_price.toFixed(2))
                                : 0
                            } `}
                            <span style={{ fontSize: "12px" }}> USD</span>
                            {")"}
                          </>
                        ) : null}
                      </div>
                    </div>
                  </td>
                  <td className="al-hxHash">
                    <div className="inherit">
                      {data.gbet_used ? (
                        <>
                          {nFormatter(data.gbet_used)}
                          <span style={{ fontSize: "14px" }}> GBET</span>{" "}
                        </>
                      ) : null}
                    </div>
                  </td>
                  {/* <td className="al-amount time">
                <div className="inherit tooltipDate">
                  <div className="tooltiptext">{`${new Date(
                    data.createdAt
                  ).toLocaleString("default", {
                    month: "short",
                  })} ${new Date(data.createdAt).getDate()}, ${new Date(
                    data.createdAt
                  ).getFullYear()} , ${new Date(data.createdAt).toLocaleString(
                    "en-US",
                    { hour: "numeric", minute: "2-digit", hour12: true }
                  )} `}</div>
                  {daysAgo(data.createdAt)}
                </div>
              </td> */}
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
}
